import React from 'react'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import ShiftExchangeSiblingShifts from 'pages/app/shifts/exchange/partials/ShiftExchangeSiblingShifts'

export default function ShiftExchangeUser ({
  namePrefix = null,
  withShiftSiblings = false,
  className = ''
}) {
  return (
    <div className={className}>
      <UI.EmployeeInfo
        width=''
        large
        avatar={<Displays.Image name={`${namePrefix}.avatar_url`} />}
        title={<Displays.Text name={`${namePrefix}.name`} />}
        text={(
          <div>
            <div className='flex flex-col space-y-1'>
              <UI.Text block>
                <Displays.Text name={`${namePrefix}.employment_name`} />
              </UI.Text>
              <UI.Text block capitalize>
                <Displays.Date name={`${namePrefix}_shift.start_at`} dateFormat='dddd DD.MM.YYYY' />
              </UI.Text>
              <UI.Text block>
                <Displays.Time name={`${namePrefix}_shift.start_at`} forceUTC /> - <Displays.Time name={`${namePrefix}_shift.end_at`} forceUTC />
              </UI.Text>
              <UI.Text block>
                <Displays.Text name={`${namePrefix}_shift.schedule.department.name`} />
              </UI.Text>
            </div>
          </div>
       )}
        badges={<Displays.Badges name={`${namePrefix}.display_badges`} big />}
      />
      {withShiftSiblings && (
        <div className='mt-8'>
          <ShiftExchangeSiblingShifts namePrefix={namePrefix} />
        </div>
      )}
    </div>
  )
}
